import React, { useEffect, useState } from 'react';
import { Loader, Notification } from 'is24-corecss';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCustomerVerificationStatus } from '../../api/tvs/customer/customerVerificationStatus';
import { DSA_DOCUMENTS_PENDING_PATH, DSA_VERIFICATION_ERROR_PATH } from '../../routePaths';
import { resolveVerificationRoutePath } from '../verificationLandingPage/verificationRouting';
import { routeWithSearch } from '../../utils/routeWithSearch';

const STATUS_POLL_INTERVAL_MS = 5000;

const DsaPendingPage: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [showStatusError, setShowStatusError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const checkVerificationStatus = async () => {
      try {
        const verificationStatus = await getCustomerVerificationStatus();
        const routePath = resolveVerificationRoutePath(verificationStatus);

        if (isMounted && routePath !== DSA_DOCUMENTS_PENDING_PATH) {
          navigate(routeWithSearch(routePath, location.search), { replace: true });
        }
      } catch {
        if (isMounted) {
          setShowStatusError(true);
          navigate(routeWithSearch(DSA_VERIFICATION_ERROR_PATH, location.search), { replace: true });
        }
      }
    };

    void checkVerificationStatus();
    const intervalId = window.setInterval(checkVerificationStatus, STATUS_POLL_INTERVAL_MS);

    return () => {
      isMounted = false;
      window.clearInterval(intervalId);
    };
  }, [location.search, navigate]);

  return (
    <div className='grid grid-flex grid-justify-center'>
      <div className='grid-item one-whole'>
        {showStatusError && (
          <Notification
            className='margin-bottom-l'
            title={t('DsaPendingPage.errorTitle')}
            message={t('DsaPendingPage.errorDescription')}
            type='error'
            showCloseIcon={false}
          />
        )}
        <div className='font-heading-small-bold margin-top-xl'>{t('DsaPendingPage.title')}</div>
        <div className='margin-top-xl'>{t('DsaPendingPage.description')}</div>
        <div className='font-s margin-top-s'>{t('DsaPendingPage.pollingHint')}</div>
        <div className='one-whole grid-align-center' style={{ justifyItems: 'center' }}>
          <Loader size='medium' aria-label={t('DsaPendingPage.loadingLabel')} className='margin-vertical-xxl' />
        </div>
      </div>
    </div>
  );
};

export default DsaPendingPage;
